import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Megaphone } from "lucide-react";

const COLS = [["total", "Assigned", "text-slate-800"], ["uncalled", "Not called", "text-amber-600"], ["contacted", "Contacted", "text-sky-600"], ["callback", "Callback", "text-violet-600"], ["interested", "Interested", "text-emerald-600"], ["not_interested", "Not int. / DNC", "text-rose-600"], ["converted", "→ Leads", "text-[#4F46E5]"], ["admitted", "Admitted", "text-emerald-700"]];

export default function MyCampaigns() {
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/dashboard/my-campaigns").then(({ data }) => setD(data)).catch(() => setD({ campaigns: [] })); }, []);
  if (!d) return null;
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5 shadow-sm mt-6" data-testid="my-campaigns">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-heading font-bold text-[#312E81] flex items-center gap-2"><Megaphone className="w-4 h-4 text-[#4F46E5]" /> {d.scope === "team" ? "Campaign Stats (all teams)" : d.scope === "myteam" ? "My Team's Campaigns" : "My Campaigns"}</h3>
        <button onClick={() => navigate("/calling-campaigns")} className="text-xs font-semibold text-[#4F46E5] hover:underline" data-testid="my-campaigns-all">All campaigns</button>
      </div>
      {!d.campaigns.length ? <div className="text-sm text-slate-400 py-6 text-center">{d.scope === "team" ? "No campaign data yet" : "No campaigns assigned to you yet"}</div> : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-[11px] uppercase tracking-wide text-slate-400 border-b">
              <th className="text-left py-2 pr-3">Campaign</th>{COLS.map(([k, l]) => <th key={k} className="text-right px-2">{l}</th>)}<th className="text-left pl-3 w-40">Progress</th></tr></thead>
            <tbody>{d.campaigns.map((c) => {
              const pct = c.total ? Math.round((c.contacted / c.total) * 100) : 0;
              const conv = c.total ? ((c.converted / c.total) * 100).toFixed(1) : "0.0";
              return (
                <tr key={c.campaign} className="border-b border-slate-50 hover:bg-indigo-50/40 cursor-pointer" onClick={() => c.campaign_id && navigate(`/calling-campaigns/${c.campaign_id}`)} data-testid={`my-campaign-${c.campaign}`}>
                  <td className="py-2 pr-3"><div className="font-semibold text-[#312E81]">{c.campaign}</div><div className="text-[11px] text-slate-400">{c.status || "—"} · {c.attempts} calls · {conv}% conversion</div></td>
                  {COLS.map(([k, , tone]) => <td key={k} className={`text-right px-2 font-semibold ${tone}`}>{c[k]}</td>)}
                  <td className="pl-3"><div className="h-2 bg-slate-100 rounded-full overflow-hidden"><div className="h-full bg-gradient-to-r from-[#312E81] to-[#6366F1]" style={{ width: `${pct}%` }} /></div><div className="text-[10px] text-slate-500 mt-0.5">{pct}% contacted</div></td>
                </tr>);
            })}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}
